export interface ICustomiseCardStepModel {
    giftCardUrl: string;
    userGiftCards: Array<string>;
    useCardTemplate: boolean;
}

export class CustomiseCardStepModel implements ICustomiseCardStepModel {
    giftCardUrl: string;
    userGiftCards: Array<string>;
    useCardTemplate: boolean;

    constructor() {
        this.giftCardUrl = "";
        this.userGiftCards = new Array<string>();
        this.useCardTemplate = true;
    }

    static isValid(model: ICustomiseCardStepModel): boolean {
        if (!model.giftCardUrl.trim()) {
            return false;
        }

        return true;
    }
}